class TestExecutionViewController {
    constructor($uibModal, $window, $route, $routeParams, $location, $browser, $scope, $confirm, ModalService, $timeout, $q, UserDetailsApi, UserServiceApi, PermissionsServiceApi, GroupTesterSimServiceApi, UtpSimServiceApi, ManageSimulatorServiceApi, UserConnectionServiceApi, TraceHubExService, toastr, TraceDetailsServiceApi, SettingsExService, ProjectTestingServiceApi, ProjectStatesServiceApi, UtpTestRunnerServiceApi, ClearingBatchServiceApi, ScriptInjectionService, TestAPIServiceApi, UtpTestExecutionServiceApi, multiTestNotificationService, ConvertService, ngProgressFactory, TestExecutionServiceApi, SimulationDataServiceApi, ApplicationsServiceApi, TestLibraryServiceApi, ResetService, TestExecutionLocalStorageService) {
        this.connectionProfiles = [];
        this.$onInit = () => {
            this.init();
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop('gt-view');
        };
        this.init = () => {
            this.selectedSim = null;
            this.userDetails = null;
            this.connectionId = '0';
            this.currentSimModel = null;
            this.state = {
                autoRefresh: true,
                isExecutionViewLoading: true,
                expandedNodes: [],
                selectedNode: null,
                checkedNodes: [],
                multiTestSentCases: [],
                multiTestState: {
                    isRunning: false,
                    isLoading: false
                },
                appSettings: null,
                dropdownItems: [
                    {
                        label: 'Simulation Data',
                        icon: 'glyphicon glyphicon-book',
                        order: 0,
                        onClick: this.openSimulationDataModal,
                        isVisible: () => { return !this.selectedSim.LiveSimulationData; },
                        isDisabled: () => { return this.state.multiTestState.isRunning; }
                    },
                    {
                        label: 'ICS',
                        icon: 'fa fa-question-circle-o',
                        order: 1,
                        onClick: this.openICSQuestionnaireModal,
                        isVisible: () => { return this.state.simHasICSQuestions; },
                        isDisabled: () => { return false; }
                    },
                    {
                        label: 'Test File Upload',
                        icon: 'fa fa-upload',
                        order: 2,
                        onClick: () => this.location.path(`/FileValidation/${this.routeParamService.userId}/${this.routeParamService.simId}`),
                        isVisible: () => { return this.selectedSim.TestFileUpload; },
                        isDisabled: () => { return false; }
                    },
                    {
                        label: 'Test Scope Update',
                        icon: 'fa fa-filter',
                        order: 3,
                        onClick: this.openTestScopeModal,
                        isVisible: () => { return this.selectedSim.TestScopeUpdate; },
                        isDisabled: () => { return false; }
                    },
                    {
                        label: 'Test File Submission',
                        icon: 'glyphicon glyphicon-flash',
                        order: 4,
                        onClick: this.openTestFileSubmissionModal,
                        isVisible: () => { return this.selectedSim.TestFileSubmission; },
                        isDisabled: () => { return false; }
                    },
                    {
                        label: 'Clear Test Case Verdicts',
                        icon: 'fa fa-file-excel-o',
                        order: 5,
                        onClick: this.resetTestCaseVerdicts,
                        isVisible: () => { return true; },
                        isDisabled: () => { return false; }
                    },
                    {
                        label: 'Delete Traces',
                        icon: 'glyphicon glyphicon-trash',
                        order: 5,
                        onClick: this.resetTestExecutionTraces,
                        isVisible: () => { return this.userDetails.IsSupport; },
                        isDisabled: () => { return false; }
                    }
                ],
                projectInfo: null,
                reports: [],
                isSimulatorRunning: true,
                testSuitesSentSuccessfully: true,
                enableProjectTesting: false,
                enableClearingValidation: false,
                enableBatches: false,
                enableConnectionStatus: false,
                canChangeConnectionProfiles: false,
                enableConnectionProfiles: false,
                runningClearingBatch: null,
                testSuites: [],
                selectedTestSuite: null,
                modelLibraries: [],
                modelLibrariesDropDownItems: [],
                maximumButtonTextLength: 20,
                connectedUserPermissions: [],
                userCanUpdateProjectState: false,
                userCanViewCMPProjects: false,
                overTheShoulder: false,
                simulatorLocked: false,
                traceDetailsOpen: false,
                projectCMPLink: {
                    Id: 0,
                    Value: ''
                },
                enableCMPProject: false,
                simHasICSQuestions: false
            };
            this.treeOptions = {
                dirSelectable: false, // Allows expanding/collpasing a folder by clicking the text rather than only the arrow
                isSelectable: (node) => {
                    // Disable selecting any node when we're running
                    return !this.state.multiTestState.isRunning;
                }
            };
            this.data = {
                treeData: []
            };
            this.sendingEmail = false;
            this.ngProgress = this.ngProgressFactory.createInstance();
            this.routeParams = this.getQueryParams();
            this.SettingsExService
                .getSettings()
                .then((response) => {
                const appSettings = response.data;
                this.TraceHubExService.connectWithSpecificTransport('gt-view', appSettings.SignalRTransport);
                // Set the connectionId on vm.state.connectionId
                this.TraceHubExService.on('gt-view', 'onInit', (connId) => {
                    this.connectionId = connId;
                });
                this.TraceHubExService.on('gt-view', 'onSimStatusChange', (args) => {
                    if (this.routeParams.simId !== args.SimId) {
                        return;
                    }
                    // status of one simulator instance changed
                    this.UtpSimServiceApi
                        .getActiveSimulatorStatus(this.routeParams.simId, this.routeParams.userId)
                        .then((response) => {
                        if (response.data.Id !== undefined && response.data.Id !== args.SimInstanceId) {
                            // simulator instance whose status changed does not match current user
                            return;
                        }
                        this.onSimulatorStatusChange(response.data ? response.data.SimStatus : undefined);
                    });
                });
                this.TraceHubExService.on('gt-view', 'onNewTraces', (dto) => {
                    if (dto.ConnectionId !== this.connectionId) {
                        return;
                    }
                    let nodes = dto.TreeViewNodes;
                    // Check if multitest is running as single test execution is also listening for new traces
                    if (this.state.multiTestState.isRunning) {
                        // check if it's a test execution instruction input request
                        let blockingInstructionNodes = nodes.filter(trace => trace.MessageType === 'Instruction-blocking');
                        if (blockingInstructionNodes.length > 0 && blockingInstructionNodes[0].Rows.length > 0
                            && blockingInstructionNodes[0].Rows[0].SimId === this.routeParams.simId
                            && blockingInstructionNodes[0].Rows[0].UserId === this.routeParams.userId) {
                            if (blockingInstructionNodes.length > 0) {
                                // open the model dialog to request user input
                                this.openTestExecutionInstructionModal(blockingInstructionNodes[0]);
                            }
                        }
                        // Also check for a Test Page modal request
                        let testPageNodes = nodes.filter(trace => trace.MessageType === 'TestPage');
                        if (testPageNodes.length > 0 && testPageNodes[0].Rows.length > 0
                            && testPageNodes[0].Rows[0].SimId === this.routeParams.simId
                            && testPageNodes[0].Rows[0].UserId === this.routeParams.userId) {
                            if (testPageNodes.length > 0) {
                                // open the model dialog to request user input
                                this.openTestPagesModal(testPageNodes[0].Id);
                            }
                        }
                    }
                    // When non-blocking there's a chance the multi-test run finished before the instruction trace has reached us
                    // But we also need to not fire up the toast when trace details is open as it will also show the toast - so we'd get two toasts
                    if (!this.state.traceDetailsOpen) {
                        let nonBlockingInstructionNodes = nodes.filter(trace => trace.MessageType === 'Instruction-non-blocking');
                        if (nonBlockingInstructionNodes.length > 0) {
                            this.toastr.info(nonBlockingInstructionNodes[0].Rows[0].fullLabel);
                        }
                    }
                });
                this.TraceHubExService.on('gt-view', 'onTestRunTestCaseStatusChange', (e) => {
                    if (e.TestRunId === this.multiTestProgress.TestRunId && e.TesterId === this.routeParams.userId) {
                        if (e.NewStatus.toString().toUpperCase() === 'RUNNING') {
                            this.updateMultiTestCaseStatus(e.TestCaseId, e.NewStatus.toString());
                        }
                        if (e.NewStatus.toString().toUpperCase() === 'COMPLETE') {
                            let runContext = _.find(this.state.multiTestSentCases, { Id: e.TestCaseId });
                            runContext.Status = e.NewStatus.toString();
                            runContext.Verdict = (VerdictType[e.Verdict]);
                            // Setting Progress update parameters received
                            this.multiTestProgress.TotalTestCount = e.TotalTestCount;
                            this.multiTestProgress.PassedTestCount = e.PassedTestCount;
                            this.multiTestProgress.FailedTestCount = e.FailedTestCount;
                            this.multiTestProgress.InconclusiveTestCount = e.InconclusiveTestCount;
                        }
                    }
                });
                /* This handler is for new multiTest run */
                this.TraceHubExService.on('gt-view', 'onTestRunStatusChange', (e) => {
                    if (e.TestRunId === this.multiTestProgress.TestRunId && e.TesterId === this.routeParams.userId) {
                        let newStatus = e.NewStatus.toString().toUpperCase();
                        if (newStatus === 'COMPLETE' || newStatus === 'CANCELLED') {
                            this.state.multiTestState.isRunning = false;
                        }
                    }
                });
                /* This handler is for old single testcase run, not multiTest run */
                this.TraceHubExService.on('gt-view', 'onTestCaseStatusChange', (e) => {
                    if (e.UserId === this.routeParams.userId) {
                        if (_.isNil(this.data.treeData)) {
                            // Tree isn't even populated yet, just discard it
                            return;
                        }
                        let nodeToUpdate = this.getTreeNode(this.data.treeData, (node) => node.TestCaseId === e.TestCaseId);
                        if (nodeToUpdate !== null) {
                            nodeToUpdate.Verdict = e.Verdict;
                            nodeToUpdate.IsTestCaseSupportOnlyRestart = e.IsTestCaseSupportOnlyRestart;
                            if (this.isTreeNodeDisabled(nodeToUpdate)) {
                                this.setTreeNodeChecked(nodeToUpdate, false);
                            }
                        }
                    }
                });
            });
            // get project states
            this.ProjectStatesServiceApi.getProjectStates().then(response => {
                const data = response.data;
                this.projectStates = data;
            });
            // get the connection profiles
            this.UserConnectionServiceApi.getAllShortConnectionProfiles(this.routeParams.simId, this.routeParams.userId).then(response => {
                this.connectionProfiles = response.data;
            });
            // get simulator reports
            this.getSimReports();
            // Initialize values before TestRun
            this.multiTestProgress = {
                TestRunId: 0,
                TotalTestCount: 0,
                PassedTestCount: 0,
                FailedTestCount: 0,
                InconclusiveTestCount: 0
            };
            this.UtpSimServiceApi.simHasICSQuestions(this.routeParams.simId, this.routeParams.userId).then((response) => {
                this.state.simHasICSQuestions = response.data;
            });
            this.UserDetailsApi.get().then((response) => {
                let connectedUser = response.data;
                // Get our user details
                this.userDetails = connectedUser;
                if ((this.userDetails.IsSupport || this.userDetails.IsProjectTester) && this.routeParams.userId) {
                    this.state.overTheShoulder = true;
                }
                this.PermissionsServiceApi.getPermissionsForConnectedUser().then((response) => {
                    this.state.connectedUserPermissions = response.data;
                    this.state.userCanUpdateProjectState = this.state.connectedUserPermissions.indexOf('wbt:update_project_state') >= 0;
                    this.state.userCanViewCMPProjects = this.state.connectedUserPermissions.indexOf('wbt:cmp_access') >= 0;
                });
                this.UtpSimServiceApi
                    .getActiveSimulatorStatus(this.routeParams.simId, this.routeParams.userId)
                    .then((response) => {
                    this.onSimulatorStatusChange(response.data ? response.data.SimStatus : undefined);
                });
            }, () => {
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
            this.UserServiceApi.getUser(this.routeParams.userId).then((response) => {
                this.selectedTester = response.data;
            });
        };
        this.onSimulatorStatusChange = (status) => {
            switch (status) {
                case 'Started':
                    this.state.isSimulatorRunning = true;
                    this.loadLibraries();
                    break;
                case 'Starting':
                case 'Stopped':
                case 'UnexpectedExit':
                case 'Error':
                case undefined: // Undefined if there is no active simulator instance
                    this.state.isSimulatorRunning = false;
                    this.loadLibraries();
                    break;
                default:
                    this.state.isSimulatorRunning = false;
                    break;
            }
        };
        this.loadLibraries = () => {
            this.SettingsExService
                .getSettings()
                .then((response) => {
                this.state.appSettings = response.data;
                this.getSimDetails().then(() => {
                    // get the lock status first as we need it for calls later in the chain
                    return this.isSimulatorLocked();
                }).then(() => {
                    return this.getTestSuites();
                }).then(() => {
                    return this.getModelLibraries();
                }).then(() => {
                    this.state.isExecutionViewLoading = false;
                });
            });
        };
        this.openTestExecutionInstructionModal = (instructionTrace) => {
            let modalInstance = this.uibModal.open({
                animation: true,
                backdrop: 'static',
                component: 'testInstructionUserInput',
                resolve: {
                    instructionTraceTreeVM: () => {
                        return instructionTrace;
                    },
                }
            });
            modalInstance.result.then(
            // close callback
            (params) => {
                let req = {
                    UserId: this.routeParams.userId,
                    SimId: this.routeParams.simId,
                    ParamValues: this.ConvertService.ToDictionary(params)
                };
                this.provideTestInstructionValues(req);
            }, 
            // dismiss callback
            () => {
                this.doStopTestRun();
            });
        };
        this.openTestPagesModal = (testPageTraceId) => {
            let modalInstance = this.uibModal.open({
                animation: true,
                backdrop: 'static',
                component: 'testPagesModal',
                resolve: {
                    testPageTraceId: () => {
                        return testPageTraceId;
                    },
                }
            });
        };
        this.openTestScopeModal = () => {
            let modalInstance = this.uibModal.open({
                animation: true,
                component: 'uploadTestCasesModal',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    selectedItems: () => {
                        return {
                            selectedTester: { Id: this.selectedTester.Id, Name: this.selectedTester.Description },
                            selectedSim: { Id: this.selectedSim.Id, Name: this.selectedSim.SimName },
                            selectedSuite: { Id: this.state.selectedTestSuite.Id, Name: this.state.selectedTestSuite.Name, ExpiryClass: null, ExpiryDate: null, ExpiryPopUpText: null, SupportsMultitest: false, TestCaseVariableCount: -1 },
                            testCases: null,
                            excludedTestCases: null,
                            showTesters: true
                        };
                    }
                }
            });
            modalInstance
                .result
                .then((result) => {
                this.selectTestSuite(this.state.selectedTestSuite);
            })
                .finally(() => {
                this.updateConnectionStatus();
            });
        };
        this.provideTestInstructionValues = (req) => {
            this.TraceDetailsServiceApi.provideTestExecutionInstructionValues(req);
        };
        this.isSimulatorLocked = () => {
            if (this.userDetails.IsGroupTester && this.userDetails.SingleSignOnDetails) {
                let req = {
                    TesterId: this.routeParams.userId,
                    SimId: this.routeParams.simId
                };
                return this.GroupTesterSimServiceApi.isSimulatorLocked(req).then((response) => {
                    let lockData = response.data;
                    if (!lockData.IsLocked) {
                        return;
                    }
                    // set a flag separate from multi-test to use to disable non-multi-test
                    // features that should not be accessed when sim is locked.
                    this.state.simulatorLocked = true;
                    // Hide multi test controls as the user can't run anything anyway
                    this.state.appSettings.MultiTestModule = false;
                    if (_.isNil(lockData.LockingError)) {
                        this.toastr.warning(`${lockData.LockingSSOUserDetails['IdPEmail']} is currently testing with the simulator. The simulator must be started by your account to enable testing.`);
                    }
                    else {
                        this.toastr.error(lockData.LockingError);
                    }
                });
            }
            else {
                return undefined;
            }
        };
        this.updateMultiTestCaseStatus = (tcId, newStatus) => {
            let tc = _.find(this.state.multiTestSentCases, { Id: tcId });
            if (tc !== null) {
                tc.Status = newStatus;
            }
        };
        this.openReport = (report) => {
            const simulator = { id: this.selectedSim.Id, type: this.selectedSim.CategoryDesc };
            this.uibModal.open({
                animation: true,
                size: 'md',
                backdrop: 'static',
                component: 'externalReport',
                resolve: {
                    report: report,
                    user: this.state.overTheShoulder ? this.selectedTester : this.userDetails,
                    simulator
                }
            });
        };
        this.openTestExecutionUI = (node) => {
            if (node.TestCaseId <= 0) {
                return;
            }
            let user = this.userDetails;
            let selectedTester = { Id: this.userDetails.Id, Name: this.userDetails.Description };
            if (this.state.overTheShoulder) {
                selectedTester = { Id: this.routeParams.userId, Name: this.userDetails.Description };
            }
            let selectedItems = {
                selectedTester: selectedTester,
                selectedSim: { Id: this.selectedSim.Id, Name: this.selectedSim.SimName },
                selectedSuite: { Id: this.state.selectedTestSuite.Id, Name: '' },
                selectedTest: { Id: node.TestCaseId, Name: '' },
                projectIterationId: _.isNil(node.projectIterationId) ? 0 : node.projectIterationId,
                selectedTraceId: -1 // Don't worry about the source trace here
            };
            let mode = { view: true, run: this.state.isSimulatorRunning };
            let tdParams = {
                selectedItems: selectedItems,
                mode: mode,
                user: user,
                overTheShoulder: this.state.overTheShoulder,
                projectTestingView: true
            };
            this.saveSelectedNode(node);
            this.state.traceDetailsOpen = true;
            let modalInstance = this.uibModal.open({
                animation: true,
                size: 'xl',
                backdrop: 'static',
                component: 'traceDetailsModal',
                resolve: {
                    params: () => {
                        return tdParams;
                    }
                }
            });
            modalInstance
                .result
                .then(() => {
                this.state.traceDetailsOpen = false;
                return;
            })
                .finally(() => {
                this.updateConnectionStatus();
            });
        };
        this.getQueryParams = () => {
            let params;
            try {
                params = {
                    userId: parseInt(this.routeParamService.userId, 10),
                    simId: parseInt(this.routeParamService.simId, 10)
                };
            }
            catch (ex) {
                this.toastr.warning(ex);
            }
            return params;
        };
        this.getModelLibraries = () => {
            if (!this.state.isSimulatorRunning) {
                this.state.modelLibraries = [];
                return this.q.resolve();
            }
            return this.SimulationDataServiceApi.getAvailableModelLibraries(this.routeParams.simId, this.routeParams.userId)
                .then((response) => {
                this.state.modelLibraries = [];
                this.state.modelLibrariesDropDownItems = [];
                // group the model libraries by model type
                const groups = [];
                response.data.forEach(i => {
                    let group = _.find(groups, j => j.name === i.SimulationDataLibraryType.Name);
                    if (!group) {
                        group = {
                            name: i.SimulationDataLibraryType.Name,
                            libraries: []
                        };
                        groups.push(group);
                    }
                    group.libraries.push(i);
                });
                // for each model type, active library should be one of the available libraries
                this.state.modelLibraries = response.data;
                groups.forEach(g => {
                    if (g.libraries.length > 0 && !g.libraries.some(x => x.IsActive)) {
                        this.setActiveModelLibrary(g.libraries[0]);
                    }
                });
                // at least one model type should reference more than one library to display model libraries' drop-down
                if (!groups.some(g => g.libraries.length > 1)) {
                    return;
                }
                // populate model libraries' drop-down
                groups.forEach(g => {
                    this.state.modelLibrariesDropDownItems.push({ isModelType: true, modelLibrary: undefined, name: g.name });
                    g.libraries.sort().forEach(m => this.state.modelLibrariesDropDownItems.push({ isModelType: false, modelLibrary: m, name: m.DisplayName }));
                });
            });
        };
        this.getTestSuites = () => {
            return this.TestExecutionServiceApi.getTestExecutionDto(this.routeParams.userId, this.routeParams.simId).then((response) => {
                this.state.testSuites = response.data.TestSuites;
                if (!_.isNil(response.data.SelectedUserTestSuite)) {
                    return this.selectTestSuite(response.data.SelectedUserTestSuite);
                }
                else {
                    // If they've started a batch but not selected a test suite yet don't select anything - this will prompt them to instead
                    if (this.state.testSuites.length > 0 && (!this.state.enableBatches || (this.state.enableBatches && !this.state.enableClearingValidation))) {
                        return this.selectTestSuite(this.state.testSuites[0]);
                    }
                }
                return undefined;
            });
        };
        this.getSimDetails = () => {
            // Need to fetch the groupTesterSimModel (not just for group testers) to see if they're using repo tests
            this.GroupTesterSimServiceApi.getSimulatorModel({ SimId: this.routeParams.simId, TesterId: this.routeParams.userId }).then((response) => {
                let simResponse = response.data;
                if (simResponse !== null) {
                    this.currentSimModel = simResponse;
                }
            });
            return this.UtpSimServiceApi.getAllSimulators(this.routeParams.userId, false, false, false, false).then((response) => {
                let activeSims = response.data;
                let idx;
                for (idx = 0; idx < activeSims.activeSimulatorsList.length; idx++) {
                    if (activeSims.activeSimulatorsList[idx].Id === this.routeParams.simId) {
                        this.selectedSim = activeSims.activeSimulatorsList[idx];
                    }
                }
                return this.UtpSimServiceApi.isSimulatorRunning(this.routeParams.userId, this.routeParams.simId).then((response) => {
                    this.state.isSimulatorRunning = response.data;
                    // Hide multi test controls when the sim isn't running - can run anything anyway
                    if (this.state.appSettings.MultiTestModule === true && !this.state.isSimulatorRunning) {
                        this.state.appSettings.MultiTestModule = false;
                    }
                    if (this.state.isSimulatorRunning) {
                        // check if we should ask for the connection for this user => sim must be static and flag for multi user connection
                        if (this.selectedSim.CategoryDesc === 'Static' && this.selectedSim.MultiConnection && !this.userDetails.IsSupport) {
                            // get the connection status for current user
                            this.UserConnectionServiceApi.getConnectionStatus(this.routeParams.simId, this.routeParams.userId).then((response) => {
                                if (!response.data.AllConnectionStatus.every(i => i.Status === 'Connected' || i.Status === 'Connecting')) {
                                    this.UserConnectionServiceApi.startConnection(this.routeParams.simId, this.routeParams.userId).then((response) => {
                                        if (!response.data) {
                                            // display a message warning the user when we haven't connected all streams of the sim
                                            this.toastr.warning('Simulator is not fully connected to all streams. Test cases may not execute correctly');
                                        }
                                    });
                                }
                            });
                        }
                    }
                    let isStaticSim = this.selectedSim.CategoryDesc === 'Static';
                    let isGroupTemplateSim = this.selectedSim.CategoryDesc === 'GroupTemplate';
                    let isTemplateSim = this.selectedSim.CategoryDesc === 'Template';
                    let isCapacitySim = this.selectedSim.TestMode === 'Stress';
                    let shallGetDataFromAPI = this.selectedSim.GetDataFromAPI;
                    // Display/hide connection status based on simulator type/configuration
                    this.state.enableConnectionStatus = (isStaticSim || isGroupTemplateSim) && shallGetDataFromAPI && !isCapacitySim && this.state.isSimulatorRunning;
                    // Indicate if the connection profiles bar should be displayed
                    this.state.enableConnectionProfiles = (isStaticSim || isGroupTemplateSim) && this.connectionProfiles.length > 1 && this.state.isSimulatorRunning;
                    this.state.canChangeConnectionProfiles = isStaticSim && this.state.connectedUserPermissions.indexOf('wbt:Project_Connection_Management') >= 0;
                    // Limit Project Testing, Clearing and Batches to static sims only just now
                    if (isStaticSim || isGroupTemplateSim || isTemplateSim) {
                        return this.getProjectInformation().then(() => {
                            if (this.state.appSettings.ProjectTestingEnabled && this.state.projectInfo !== null) {
                                this.state.enableProjectTesting = true;
                                if (this.state.projectInfo.Id !== undefined && this.state.projectInfo.Id !== null) {
                                    this.ProjectTestingServiceApi.getTestProjectLinkForTestProject(this.state.projectInfo.Id).then((response) => {
                                        if (response.data.Id === this.state.projectInfo.Id) {
                                            this.state.projectCMPLink = response.data;
                                            if (this.state.projectCMPLink.Value !== '') {
                                                this.state.enableCMPProject = true;
                                            }
                                        }
                                    });
                                }
                            }
                            if (this.selectedSim.CategoryDesc === 'Static' && this.state.enableProjectTesting) {
                                this.UtpSimServiceApi.isSimLinkedToClearingSim(this.routeParams.userId, this.routeParams.simId)
                                    .then((response) => {
                                    // sim is linked to a clearing sim so enable the Clearing options
                                    if (response.data === true) {
                                        this.state.enableClearingValidation = true;
                                    }
                                });
                            }
                            if (this.selectedSim.BatchTesting && this.state.isSimulatorRunning) {
                                this.state.enableBatches = true;
                                return this.ClearingBatchServiceApi.syncBatches(this.routeParams.userId, this.routeParams.simId).
                                    then(() => this.ClearingBatchServiceApi.getRunningBatch(this.routeParams.userId, this.routeParams.simId)).then((response) => {
                                    if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
                                        this.state.runningClearingBatch = response.data;
                                    }
                                    else {
                                        this.state.runningClearingBatch = null;
                                    }
                                });
                            }
                            else {
                                return undefined;
                            }
                        });
                    }
                    else {
                        return undefined;
                    }
                });
            });
        };
        this.getProjectInformation = () => {
            return this.ProjectTestingServiceApi.getProject(this.routeParams.userId, this.routeParams.simId).
                then((response) => {
                const projectResponse = response.data;
                if (projectResponse !== null && angular.isDefined(projectResponse.Id) && projectResponse.Id > 0) {
                    this.state.projectInfo = response.data;
                }
                else {
                    this.state.projectInfo = null;
                }
            });
        };
        this.getSimReports = () => {
            return this.UtpSimServiceApi.getSimulatorReports(this.routeParams.simId, this.routeParams.userId).
                then((response) => {
                if (!_.isEmpty(response.data)) {
                    this.state.reports = response.data;
                }
            });
        };
        this.openSimulationDataModal = () => {
            let modalInstance = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'editSimulationDataInstancesModal',
                size: 'xl',
                resolve: {
                    testerId: () => {
                        return this.routeParams.userId;
                    },
                    simId: () => {
                        return this.routeParams.simId;
                    }
                }
            });
            modalInstance
                .result
                .then((modalResult) => {
                return;
            }, 
            // dismiss callback
            (modalResult) => {
                // reload the test suite to push any sim data updates to the sim in the /user/testplan API call
                this.selectTestSuite(this.state.selectedTestSuite);
            })
                .finally(() => {
                this.updateConnectionStatus();
            });
        };
        this.openICSQuestionnaireModal = () => {
            let modalInstance = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'icsQuestionnaireModal',
                size: 'xl',
                resolve: {
                    userId: () => {
                        return this.routeParams.userId;
                    },
                    simId: () => {
                        return this.routeParams.simId;
                    },
                    testSuiteId: () => {
                        return 0;
                    },
                    readOnly: () => {
                        return this.userDetails.IsSupport;
                    },
                    userName: () => {
                        // Due to how IdPId works (IdPId is stored only in the cookie for the current user) the IdP name can never be retrieved here
                        return this.selectedTester.UserName;
                    },
                    simulatorName: () => {
                        return this.selectedSim.SimName;
                    }
                }
            });
            modalInstance
                .result
                .then((modalResult) => {
                // reload the test suite to push any sim data updates to the sim in the /user/testplan API call
                this.selectTestSuite(this.state.selectedTestSuite);
            }, 
            // dismiss callback
            (modalResult) => {
                // reload the test suite to push any sim data updates to the sim in the /user/testplan API call
                this.selectTestSuite(this.state.selectedTestSuite);
            })
                .finally(() => {
                this.updateConnectionStatus();
            });
        };
        this.openTestFileSubmissionModal = () => {
            let modalInstance = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'testFileSubmissionModal',
                size: 'md',
                resolve: {
                    testerId: () => {
                        return this.routeParams.userId;
                    },
                    simId: () => {
                        return this.routeParams.simId;
                    }
                }
            });
            modalInstance
                .result
                .then((modalResult) => {
                // Do nothing, modal handles everything
            }, 
            // dismiss callback
            (modalResult) => {
                // Do nothing, modal handles everything
            })
                .finally(() => {
                this.updateConnectionStatus();
            });
        };
        this.uploadProjectAttachments = () => {
            this.location.path('/ProjectAttachments/TestProjects/' + this.state.projectInfo.Id);
        };
        this.openProjectDetailsModal = () => {
            let modalInstance = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'projectDetails',
                size: 'xl',
                resolve: {
                    testerId: () => {
                        return this.routeParams.userId;
                    },
                    simId: () => {
                        return this.routeParams.simId;
                    },
                    projectId: () => {
                        return this.state.projectInfo.Id;
                    }
                }
            });
            modalInstance.result.then(() => {
                return;
            });
        };
        this.openClearingValidation = () => {
            this.location.path(`/ClearingValidation/${this.routeParams.userId}/${this.routeParams.simId}`);
        };
        this.updateProject = (state) => {
            if (!this.state.userCanUpdateProjectState)
                return;
            if (state.MailRequired && this.state.appSettings.TestProjectStateChangeNotificationEmailList === '') {
                this.toastr.error('Email address is missing for this action. Contact Support.');
            }
            else {
                this.sendingEmail = true;
            }
            return this.ProjectTestingServiceApi.
                changeProjectState(this.state.projectInfo.Id, state.Id).
                then((response) => {
                if (this.sendingEmail) {
                    let result = response.data;
                    if (result.errors.length > 0) {
                        for (let res of result.errors) {
                            this.toastr.error(res);
                        }
                    }
                    else {
                        this.toastr.info('Project state updated successfully');
                    }
                    this.sendingEmail = false;
                }
                return this.getProjectInformation();
            }, () => { this.sendingEmail = false; });
        };
        this.expandAllTreeNodes = (children) => {
            _.each(children, (leaf) => {
                if (leaf.children) {
                    this.state.expandedNodes.push(leaf);
                    this.expandAllTreeNodes(leaf.children);
                }
            });
        };
        this.collapseAllTreeNodes = () => {
            this.state.expandedNodes = [];
        };
        this.selectAllTreeNodes = (checked) => {
            for (let node of this.data.treeData) {
                if (!this.isTreeNodeDisabled(node)) {
                    this.setTreeNodeChecked(node, checked);
                }
            }
        };
        this.getTreeNode = (treeData, callback) => {
            for (let childNode of treeData) {
                if (callback(childNode)) {
                    return childNode;
                }
                if (childNode.children && childNode.children.length > 0) {
                    let foundNode = this.getTreeNode(childNode.children, callback);
                    if (foundNode !== null) {
                        return foundNode;
                    }
                }
            }
            return null;
        };
        this.onTreeNodeCheckboxClick = (node, $event) => {
            // Stop the propagation to make sure we don't expand the folder or open the test case
            $event.stopPropagation();
            if (this.isTreeNodeDisabled(node)) {
                return;
            }
            this.setTreeNodeChecked(node, !this.isTreeNodeChecked(node));
            this.saveSelectedNode(node);
        };
        this.refreshParentTreeNode = (node) => {
            // In order for the rest of the tree logic to work we need to make sure all ancestors of a node are in the right state.
            // Meaning if a folder has any checked children then it also needs to be checked
            if (node.Parent) {
                let shouldBeChecked = node.Parent.children.filter(n => this.isTreeNodeChecked(n)).length > 0;
                this.setSingleTreeNodeChecked(node.Parent, shouldBeChecked);
                this.refreshParentTreeNode(node.Parent);
            }
        };
        this.setSingleTreeNodeChecked = (node, checked) => {
            if (checked) {
                if (!this.isTreeNodeChecked(node) && node.SupportsMultiTest) {
                    this.state.checkedNodes.push(node);
                }
            }
            else {
                _.remove(this.state.checkedNodes, (loopNode) => {
                    return loopNode.Id === node.Id;
                });
            }
            this.refreshParentTreeNode(node);
        };
        this.setTreeNodeChecked = (node, checked) => {
            this.setSingleTreeNodeChecked(node, checked);
            for (let child of node.children) {
                if (!this.isTreeNodeDisabled(child)) {
                    this.setTreeNodeChecked(child, checked);
                }
            }
        };
        this.hasDropDownItems = () => {
            return this.state.dropdownItems && this.state.dropdownItems.filter(i => i.isVisible()).length > 0;
        };
        this.isTreeNodeChecked = (node) => {
            return this.state.checkedNodes.indexOf(node) > -1;
        };
        this.isTreeNodeDisabled = (node) => {
            return this.state.multiTestState.isRunning || !node.SupportsMultiTest || !this.state.selectedTestSuite.MultiTest || (node.IsTestCaseSupportOnlyRestart && !this.userDetails.IsSupport);
        };
        this.getTestCasesFromList = (nodeList) => {
            return _.filter(nodeList, (node) => {
                return node.TestCaseId > 0;
            });
        };
        this.getTreeNodeCheckboxClass = (node) => {
            let checkboxIcon = '';
            if (node.children && node.children.length > 0) {
                // Folders
                let checkedChildren = node.children.filter(childNode => {
                    return this.isTreeNodeChecked(childNode);
                });
                if (checkedChildren.length > 0 && checkedChildren.length < node.children.length) {
                    // Some are checked - minus seems to be the done thing to show this
                    checkboxIcon = 'fa-minus';
                }
                else if (checkedChildren.length === node.children.length) {
                    // All checked
                    checkboxIcon = 'fa-check';
                }
            }
            else {
                // Test cases
                if (this.isTreeNodeChecked(node)) {
                    checkboxIcon = 'fa-check';
                }
            }
            // Change the colour a bit so the user can tell the checkbox is disabled
            if (this.isTreeNodeDisabled(node)) {
                checkboxIcon += ' text-muted';
            }
            return checkboxIcon;
        };
        this.getPercentage = (count) => {
            if (this.multiTestProgress.TotalTestCount === 0) {
                return 0;
            }
            return ((count / this.multiTestProgress.TotalTestCount) * 100);
        };
        this.refreshSelectedLibrary = () => {
            if (!this.state.selectedTestSuite) {
                return; // there's no test suite to refresh
            }
            // Reset everything for the new suite
            this.state.testSuitesSentSuccessfully = true;
            this.state.expandedNodes = [];
            this.state.checkedNodes = [];
            this.data.treeData = [];
            this.state.isExecutionViewLoading = true;
            this.TestLibraryServiceApi.getActiveTestLibrary(this.routeParams.simId, this.routeParams.userId).then((response) => {
                if (response.data) {
                    if (response.data.Name === this.state.selectedTestSuite.Name) {
                        this.UtpTestRunnerServiceApi.syncSuite(this.routeParams.userId, this.routeParams.simId).then((response) => {
                            if (response.data) {
                                const req = {
                                    SuiteName: this.state.selectedTestSuite.Name,
                                    SimId: this.routeParams.simId,
                                    UserId: this.routeParams.userId,
                                    SuiteId: this.state.selectedTestSuite.Id,
                                    TestId: 0
                                };
                                let p = this.processICS();
                                // Whether we do some ICS processing or not we still want to move to the next step in the chain
                                if (p === undefined) {
                                    return this.getTestSuiteStructure(req);
                                }
                                else {
                                    return p.then(() => {
                                        return this.getTestSuiteStructure(req);
                                    });
                                }
                            }
                            else {
                                this.toastr.error('Error synchronising test suite during refresh.');
                                this.state.testSuitesSentSuccessfully = false;
                                this.state.expandedNodes = [];
                                this.state.checkedNodes = [];
                                this.data.treeData = [];
                                this.state.isExecutionViewLoading = false;
                                return undefined;
                            }
                        });
                    }
                    else {
                        this.toastr.error('Error fetching active test suite during refresh.');
                        this.state.testSuitesSentSuccessfully = false;
                        this.state.expandedNodes = [];
                        this.state.checkedNodes = [];
                        this.data.treeData = [];
                        this.state.isExecutionViewLoading = false;
                        return undefined;
                    }
                }
            });
        };
        this.startTestRun = () => {
            this.ngProgress.start();
            this.state.multiTestState.isLoading = true;
            let runTestReq = {
                UserId: this.routeParams.userId,
                SimId: this.routeParams.simId,
                SuiteId: this.state.selectedTestSuite.Id,
                TestCaseIds: this.state.checkedNodes.map(({ TestCaseId }) => TestCaseId).filter(id => id > 0)
            };
            this.resetProgress();
            this.multiTestProgress.TotalTestCount = runTestReq.TestCaseIds.length;
            this.multiTestProgress.InconclusiveTestCount = runTestReq.TestCaseIds.length;
            this.UtpTestExecutionServiceApi.isAnyTestCaseCurrentlyRunning(this.routeParams.userId, this.routeParams.simId)
                .then((response) => {
                let checkDto = response.data;
                if (checkDto && checkDto.IsTestCaseRunning) {
                    this.toastr.info('A test is currently underway. Please wait until it is finished and try again');
                    this.state.multiTestState.isLoading = false;
                    this.resetProgress();
                    this.ngProgress.complete();
                }
                else {
                    this.UtpTestRunnerServiceApi.runMultipleTests(runTestReq).then((response) => {
                        let runId = response.data;
                        this.state.multiTestState.isLoading = false;
                        this.ngProgress.complete();
                        if (runId <= 0) {
                            this.toastr.error('Cannot start test(s). Please contact your administrator if this problem persists');
                            this.state.multiTestState.isRunning = false;
                            this.resetProgress();
                        }
                        else {
                            // Change test case status to queued as default
                            this.state.multiTestSentCases = this.state.checkedNodes.map(({ TestCaseId, label, Verdict }) => {
                                return {
                                    Id: TestCaseId,
                                    Name: label,
                                    Status: 'Queued',
                                    Verdict: ''
                                };
                            }).filter(({ Id }) => Id > 0);
                            this.multiTestProgress.TestRunId = runId;
                            this.state.multiTestState.isRunning = true;
                            this.notifyMultiTest();
                            this.updateConnectionStatus();
                        }
                    });
                }
            });
        };
        this.notifyMultiTest = () => {
            /* Emit global event */
            let e = {
                testerId: this.routeParams.userId,
                simId: this.routeParams.simId,
                suiteId: this.state.selectedTestSuite.Id,
                multiTestIsRunning: this.state.multiTestState.isRunning
            };
            this.multiTestNotificationService.changeAllOnMultiTestRun(e);
        };
        this.stopTestRun = () => {
            let modalOptions = {
                backdrop: 'static',
                actionButtonText: 'Cancel Test Run',
                closeButtonText: 'Do not cancel Test Run',
                headerText: 'Cancel Test Run',
                bodyText: 'Testing is currently in progress. Are you sure you want to cancel the test run?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                this.doStopTestRun();
            });
        };
        this.doStopTestRun = () => {
            this.ngProgress.start();
            this.state.multiTestState.isLoading = true;
            let cancelTestReq = {
                UserId: this.routeParams.userId,
                SimId: this.routeParams.simId,
                SuiteId: this.state.selectedTestSuite.Id
            };
            this.UtpTestRunnerServiceApi.cancelMultipleTests(cancelTestReq).then((response) => {
                this.ngProgress.complete();
                this.state.multiTestState.isLoading = false;
                this.state.multiTestState.isRunning = false;
                this.toastr.info('Test run cancelled');
                this.notifyMultiTest();
            });
        };
        this.resetTestCaseVerdicts = () => {
            const userId = this.routeParams.userId;
            const simId = this.routeParams.simId;
            const suiteId = this.state.selectedTestSuite.Id;
            const suiteName = this.state.selectedTestSuite.Name;
            this.ResetService
                .resetTestCaseVerdicts(userId, simId, suiteId, () => {
                this.refreshVerdicts(userId, simId, suiteId, suiteName, false);
            });
        };
        this.resetTestExecutionTraces = () => {
            const userId = this.routeParams.userId;
            const simId = this.routeParams.simId;
            const suiteId = this.state.selectedTestSuite.Id;
            const suiteName = this.state.selectedTestSuite.Name;
            this.ResetService
                .resetTestExecutionTraces(userId, simId, suiteId, () => {
                this.refreshVerdicts(userId, simId, suiteId, suiteName, true);
            });
        };
        this.resetProgress = () => {
            this.multiTestProgress.TestRunId = 0;
            this.multiTestProgress.TotalTestCount = 0;
            this.multiTestProgress.PassedTestCount = 0;
            this.multiTestProgress.FailedTestCount = 0;
            this.multiTestProgress.InconclusiveTestCount = 0;
        };
        this.startBatch = () => {
            let modalInstance = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'inputTextModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return 'Start New Batch';
                    },
                    iconClass: () => {
                        return 'glyphicon glyphicon-record';
                    },
                    inputTitle: () => {
                        return 'Batch Reference';
                    },
                    initialInputValue: () => {
                        return `${moment().format(this.state.appSettings.DateTimeFormat)} My Batch`;
                    },
                    okButtonText: () => {
                        return 'Start';
                    },
                    cancelButtonText: () => {
                        return 'Cancel';
                    }
                }
            });
            modalInstance.result.then((reference) => {
                if (this.ScriptInjectionService.isInjectedScript(reference)) {
                    this.toastr.error('Reference contains illegal characters');
                    return;
                }
                this.ClearingBatchServiceApi.startNewBatch(this.routeParams.userId, this.routeParams.simId, reference)
                    .then((response) => {
                    if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
                        if (response.status === 200) {
                            this.state.runningClearingBatch = response.data;
                            // If there's only one test suite then select it automatically
                            if (this.state.testSuites.length === 1) {
                                this.selectTestSuite(this.state.testSuites[0]);
                            }
                            this.toastr.info(`${reference} started`);
                        }
                        else {
                            this.toastr.error('Unable to start batch');
                        }
                    }
                });
            });
        };
        this.endBatch = () => {
            this.confirm({}, {
                defaultLabels: {
                    title: 'End Batch',
                    text: `Are you sure you want to end ${this.state.runningClearingBatch.Reference}? You will not be able to restart it.`,
                    ok: `End ${this.state.runningClearingBatch.Reference}`,
                    cancel: 'Cancel'
                }
            }).then(() => {
                this.ClearingBatchServiceApi.endBatch(this.routeParams.userId, this.routeParams.simId)
                    .then((response) => {
                    let batchReference = this.state.runningClearingBatch.Reference;
                    if (response && response.data) {
                        if (response.status === 200) {
                            // only null the selectedTestSuite when ending a batch if we have clearing enabled (sim is linked to a clearing sim)
                            if (this.state.enableClearingValidation) {
                                this.selectTestSuite(null);
                            }
                            this.state.runningClearingBatch = null;
                            this.toastr.info(`${batchReference} ended`);
                        }
                        else {
                            this.toastr.error('Unable to close batch');
                        }
                    }
                });
            });
        };
        this.processICS = () => {
            // Dont call the sim API if we are over the shoulder or a concurrent user
            if (!this.state.simulatorLocked) {
                return this.UtpSimServiceApi.processTestScopeUpdate(this.routeParams.userId, this.routeParams.simId).then((response) => {
                    // if we have got here, we are not over the shoulder and the sim is not locked
                    // So we can do the ICS processing.
                    if (response.data.TotalExcludedTests > 0) {
                        let message = '';
                        if (response.data.ICSEnabled && response.data.TestScopeUpdateEnabled) {
                            message = `ICS and Test Scope adjustments applied - ${response.data.TotalExcludedTests} test case(s) excluded`;
                        }
                        else if (response.data.ICSEnabled) {
                            message = `ICS applied - ${response.data.TotalExcludedTests} test case(s) excluded`;
                        }
                        else if (response.data.TestScopeUpdateEnabled) {
                            message = `Test Scope adjustments applied - ${response.data.TotalExcludedTests} test case(s) excluded`;
                        }
                        else {
                            return;
                        }
                        this.toastr.info(message);
                    }
                });
            }
            return undefined;
        };
        this.convertTestLibTreeNode = (node, parent) => {
            const newNode = {
                Id: node.Id,
                caption: node.caption,
                children: [],
                ClearingVerdict: node.ClearingVerdict,
                IsTestCaseSupportOnlyRestart: node.IsTestCaseSupportOnlyRestart,
                label: node.label,
                Parent: parent,
                SupportsMultiTest: node.SupportsMultiTest,
                TestCaseId: node.TestCaseId,
                Verdict: node.Verdict,
                WaiverStatus: node.WaiverStatus
            };
            newNode.children = node.children.map(child => this.convertTestLibTreeNode(child, newNode));
            return newNode;
        };
        this.getTestSuiteStructure = (req) => {
            // refresh the content of the test suite
            return this.TestExecutionServiceApi.getTestSuites(this.routeParams.userId, this.routeParams.simId, req.SuiteId).then((response) => {
                this.state.selectedTestSuite.MultiTest = response.data.SupportsMultiTest;
                this.data.treeData = [this.convertTestLibTreeNode(response.data, undefined)];
                // Expand the first node
                this.state.expandedNodes = [response.data];
                this.selectLastSelectedNode();
                // If the sim is running no point saying the test suite couldn't be set - it's implied
                if (this.state.isSimulatorRunning) {
                    this.state.testSuitesSentSuccessfully = true;
                }
                /* Check and Load Multi Test Run State */
                return this.UtpTestRunnerServiceApi.getRunningMultiTests(this.routeParams.userId, this.routeParams.simId, this.state.selectedTestSuite.Id)
                    .then((response) => {
                    this.restoreMultiTestRun(response.data);
                    this.state.isExecutionViewLoading = false;
                });
            });
        };
        this.setActiveModelLibrary = (selectedItem) => {
            if (selectedItem.IsActive) {
                return;
            }
            const simId = this.routeParams.simId;
            const userId = this.routeParams.userId;
            const modelLibraryTypeUid = selectedItem.SimulationDataLibraryType.LibTypeUid;
            const modelLibraryUid = selectedItem.LibUid;
            this.SimulationDataServiceApi
                .setActiveModelLibrary(simId, userId, modelLibraryTypeUid, modelLibraryUid)
                .then((response) => {
                if (response.status !== 200) {
                    this.toastr.error(`'${selectedItem.Name}' could not be set as active (${response.statusText})`);
                    return;
                }
                this.state.modelLibraries
                    .filter((x) => { return x.SimulationDataLibraryType.LibTypeUid === modelLibraryTypeUid; })
                    .forEach((x) => { x.IsActive = (x === selectedItem); });
                this.toastr.info(`'${selectedItem.Name}' was successfully set as active`);
            });
        };
        this.selectTestSuite = (selectedItem) => {
            if (!this.enableTestSuiteSelection()) {
                return undefined;
            }
            // Reset everything for the new suite
            this.state.testSuitesSentSuccessfully = true;
            this.state.expandedNodes = [];
            this.state.checkedNodes = [];
            this.data.treeData = [];
            this.state.selectedTestSuite = selectedItem;
            // If it's null then we're resetting it to "no selection"
            if (selectedItem !== null) {
                let testSuiteExists = _.some(this.state.testSuites, (item) => {
                    return item.Name === selectedItem.Name;
                });
                if (!testSuiteExists) {
                    this.toastr.error(`${selectedItem.Name} no longer exists`);
                    return undefined;
                }
                let req = {
                    SuiteName: this.state.selectedTestSuite !== null ? this.state.selectedTestSuite.Name : '',
                    SimId: this.routeParams.simId,
                    UserId: this.routeParams.userId,
                    SuiteId: this.state.selectedTestSuite !== null ? this.state.selectedTestSuite.Id : -1,
                    TestId: 0
                };
                this.state.isExecutionViewLoading = true;
                return this.UtpTestRunnerServiceApi.selectSuite(req).then((response) => {
                    if (response.data.SelectedTestSuiteId > 0) {
                        // even if the test suite is selected, we may have encountered some problems flagged as warning
                        // => notify the user
                        response.data.Result.warnings.forEach(i => this.toastr.warning(i));
                        let p = this.processICS();
                        // set the test suite id to the id sent back
                        req.SuiteId = response.data.SelectedTestSuiteId;
                        this.state.selectedTestSuite.Id = response.data.SelectedTestSuiteId;
                        // Whether we do some ICS processing or not we still want to move to the next step in the chain
                        if (p === undefined) {
                            return this.getTestSuiteStructure(req);
                        }
                        else {
                            return p.then(() => {
                                return this.getTestSuiteStructure(req);
                            });
                        }
                    }
                    else {
                        this.toastr.error('Error selecting test suite.');
                        this.state.testSuitesSentSuccessfully = false;
                        this.state.expandedNodes = [];
                        this.state.checkedNodes = [];
                        this.data.treeData = [];
                        this.state.isExecutionViewLoading = false;
                        return undefined;
                    }
                });
            }
            else {
                return this.UtpTestRunnerServiceApi.deselectSuite(this.routeParams.userId, this.routeParams.simId).then((response) => {
                });
            }
        };
        this.restoreMultiTestRun = (runningTestCases) => {
            this.state.checkedNodes = [];
            this.state.multiTestSentCases = [];
            runningTestCases.forEach(runningTest => {
                // Running test will not have the unique node Id as they are generated on each tree request
                // So we have to find the matching test case another way
                let node = this.getTreeNode(this.data.treeData, (node) => node.TestCaseId === runningTest.TestCaseId);
                this.setSingleTreeNodeChecked(node, true);
                this.state.multiTestSentCases.push({
                    Id: runningTest.TestCaseId,
                    Name: node.label,
                    Status: TestRunTestCaseStatus[runningTest.Status],
                    Verdict: VerdictType[runningTest.Verdict]
                });
            });
            if (this.state.checkedNodes.length > 0) {
                this.state.multiTestState.isRunning = !this.state.multiTestState.isRunning;
                /* TestRunTestCases are running under this TestRunId */
                this.multiTestProgress.TestRunId = runningTestCases[0].TestRunId;
                /* Emit global event */
                let e = {
                    simId: this.routeParams.simId,
                    testerId: this.routeParams.userId,
                    suiteId: this.state.selectedTestSuite.Id,
                    multiTestIsRunning: this.state.multiTestState.isRunning
                };
                this.multiTestNotificationService.changeAllOnMultiTestRun(e);
            }
        };
        this.resolveMultiRunTestCaseIcon = (testCaseNode) => {
            if (_.some(this.state.multiTestSentCases, x => x.Id === testCaseNode.TestCaseId)) {
                let runContext = _.find(this.state.multiTestSentCases, x => x.Id === testCaseNode.TestCaseId);
                if (runContext.Status.toUpperCase() === 'COMPLETE') {
                    return runContext.Verdict.toUpperCase();
                }
                return runContext.Status.toUpperCase();
            }
            return 'NOT_RUNNING';
        };
        this.toggleAutoRefresh = () => {
            this.state.autoRefresh = !this.state.autoRefresh;
            if (this.state.autoRefresh) {
                this.$scope.$broadcast("testExecutionLogRefresh");
            }
        };
        this.enableModelLibrarySelection = () => {
            return this.enableLibrarySelection();
        };
        this.enableTestSuiteSelection = () => {
            return this.enableLibrarySelection();
        };
        this.enableLibrarySelection = () => {
            if (this.state.multiTestState.isRunning) {
                // The most important rule - no test suite changes while tests are running
                return false;
            }
            if (this.state.multiTestState.isLoading) {
                // Either a new test run is starting or running test run is being cancelled
                return false;
            }
            if (this.state.enableBatches && this.state.enableClearingValidation) {
                // When the current sim is linked to a Clearing sim and we have batching enabled
                // we want to force the user to select a test suite before running any tests - otherwise
                // they could end up doing a whole load of testing that doesn't get recorded in a batch
                // If batching is enabled but we are not using a sim linked to a Clearing sim then we dont
                // want to add this restriction.
                return this.state.runningClearingBatch !== null;
            }
            return true;
        };
        this.showListOfErrors = (errors) => {
            for (let error of errors) {
                this.toastr.error(error);
            }
        };
        this.viewCMPProject = () => {
            this.window.open(`${this.state.projectCMPLink.Value}`, '_top');
        };
        this.viewRUFTestPrep = () => {
            let route = `/TestPreparation/${this.routeParams.simId}`;
            if (this.userDetails.IsProjectTester || this.userDetails.IsSupport) {
                route += `/${this.routeParams.userId}`;
            }
            this.location.path(route);
        };
        this.updateConnectionStatus = () => {
            if (this.connectionStatusController === undefined) {
                return;
            }
            this.connectionStatusController.update();
        };
        this.selectConnectionProfile = (profile) => {
            if (!this.state.canChangeConnectionProfiles)
                return;
            let modalOptions = {
                backdrop: 'static',
                actionButtonText: 'OK',
                closeButtonText: 'Cancel',
                headerText: 'Update Simulator Configuration Profile',
                bodyText: 'You are about to alter the configuration profile for the simulator. This will result in all the existing connections being dropped and may impact testing being performed on this simulator.<br/>Do you wish to continue?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                this.UserConnectionServiceApi.selectConnectionProfile(this.routeParams.simId, this.routeParams.userId, profile.Id).then(response => {
                    if (response.data) {
                        this.connectionProfiles = this.connectionProfiles.map((i) => {
                            return {
                                Id: i.Id,
                                IsActive: i.Id === profile.Id,
                                Name: i.Name
                            };
                        });
                        this.connectionStatusController.update();
                    }
                });
            });
        };
        this.getActiveConnectionProfile = () => {
            const result = this.connectionProfiles.filter(i => i.IsActive);
            return result.length > 0 ? result[0] : undefined;
        };
        this.window = $window;
        this.browser = $browser;
        this.uibModal = $uibModal;
        this.ModalService = ModalService;
        this.q = $q;
        this.UserDetailsApi = UserDetailsApi;
        this.UserServiceApi = UserServiceApi;
        this.toastr = toastr;
        this.location = $location;
        this.route = $route;
        this.routeParamService = $routeParams;
        this.GroupTesterSimServiceApi = GroupTesterSimServiceApi;
        this.UserConnectionServiceApi = UserConnectionServiceApi;
        this.PermissionsServiceApi = PermissionsServiceApi;
        this.UtpSimServiceApi = UtpSimServiceApi;
        this.ManageSimulatorServiceApi = ManageSimulatorServiceApi;
        this.TraceHubExService = TraceHubExService;
        this.TraceDetailsServiceApi = TraceDetailsServiceApi;
        this.SettingsExService = SettingsExService;
        this.ProjectTestingServiceApi = ProjectTestingServiceApi;
        this.ProjectStatesServiceApi = ProjectStatesServiceApi;
        this.UtpTestRunnerServiceApi = UtpTestRunnerServiceApi;
        this.ClearingBatchServiceApi = ClearingBatchServiceApi;
        this.confirm = $confirm;
        this.ScriptInjectionService = ScriptInjectionService;
        this.TestApiService = TestAPIServiceApi;
        this.multiTestNotificationService = multiTestNotificationService;
        this.UtpTestExecutionServiceApi = UtpTestExecutionServiceApi;
        this.ngProgressFactory = ngProgressFactory;
        this.ConvertService = ConvertService;
        this.TestExecutionServiceApi = TestExecutionServiceApi;
        this.SimulationDataServiceApi = SimulationDataServiceApi;
        this.ApplicationsServiceApi = ApplicationsServiceApi;
        this.TestLibraryServiceApi = TestLibraryServiceApi;
        this.ResetService = ResetService;
        this.$scope = $scope;
        this.localStorageService = TestExecutionLocalStorageService;
    }
    refreshVerdicts(userId, simId, suiteId, suiteName, refreshTestExecutionLog) {
        this.resetProgress();
        let req = {
            UserId: userId,
            SimId: simId,
            SuiteId: suiteId,
            SuiteName: suiteName,
            TestId: 0
        };
        if (refreshTestExecutionLog) {
            this.state.isExecutionViewLoading = true;
        }
        this.getTestSuiteStructure(req)
            .then(() => {
            if (refreshTestExecutionLog) {
                this.state.isExecutionViewLoading = false;
            }
        });
    }
    /** Event handler called when a node is expanded or collapsed */
    onNodeToggle(node) {
        this.saveSelectedNode(node);
    }
    /** Saves selected node to Local Storage.
     * Note: this method logs exceptions in the console but never propagate them since it is considered as a non-crucial operation */
    saveSelectedNode(node) {
        try {
            this.setSelectedNodeToLocalStorage(node);
        }
        catch (ex) {
            console.warn(`Test Execution component failed to save selected node to Local Storage.\n`, ex);
        }
    }
    /** Selects last selected node which was stored to Local Storage.
     * Note: this method logs exceptions in the console but never propagate them since it is considered as a non-crucial operation */
    selectLastSelectedNode() {
        try {
            const lastSelectedNodePath = this.getSelectedNodeFromLocalStorage();
            if (!lastSelectedNodePath) {
                return;
            }
            this.selectNode(lastSelectedNodePath);
        }
        catch (ex) {
            console.warn(`Test Execution component failed to select last selected node which was saved to Local Storage.\n`, ex);
        }
    }
    /** Retrieves path of last selected node from Local Storage */
    getSelectedNodeFromLocalStorage() {
        const state = this.localStorageService.getState();
        return state.SelectedNodePath;
    }
    /** Selects node (when applicable) and store its path to Local Storage */
    setSelectedNodeToLocalStorage(node) {
        this.doSelectNode(node);
        const nodePath = this.getNodePath(node);
        this.localStorageService.updateState((state) => { state.SelectedNodePath = nodePath; });
    }
    /** Gets node's path */
    getNodePath(node) {
        if (!node) {
            return null;
        }
        const parent = node.Parent;
        return parent ? `${this.getNodePath(parent)}.${node.caption}` : node.caption;
    }
    /** Gets collection of nodes matching path. This includes the node matching nodePath
     * as well as all parent nodes.
     */
    getNodesMatchingPath(nodePath) {
        if (!nodePath) {
            return [];
        }
        const splitPath = nodePath.trim().split('.');
        let retrievedNodes = [];
        for (let i = 0; i < splitPath.length; i++) {
            const nodeName = splitPath[i];
            if (!nodeName) {
                return [];
            }
            const candidates = retrievedNodes.length === 0 ? this.data.treeData : retrievedNodes[retrievedNodes.length - 1].children;
            const retrievedNode = this.getTreeNode(candidates, (x) => { return x.caption === nodeName; });
            if (!retrievedNode) {
                return [];
            }
            retrievedNodes.push(retrievedNode);
        }
        return retrievedNodes;
    }
    /** Selects node matching nodePath after ensuring all parent nodes are expanded */
    selectNode(nodePath) {
        const nodesMatchingPath = this.getNodesMatchingPath(nodePath);
        if (!nodesMatchingPath || nodesMatchingPath.length === 0) {
            return;
        }
        nodesMatchingPath.forEach(x => {
            if (this.state.expandedNodes.find(y => y === x)) {
                return;
            }
            this.state.expandedNodes.push(x);
        });
        const nodeMatchingPath = nodesMatchingPath.pop();
        this.doSelectNode(nodeMatchingPath);
        this.makeNodeVisible(nodeMatchingPath);
    }
    /** Selects node in the tree view if node matches a test case.
     * Otherwise, clears the selected node (folders are not meant to be displayed as selected, for instance).
     */
    doSelectNode(node) {
        if (node.TestCaseId > 0) {
            this.state.selectedNode = node;
        }
        else {
            this.state.selectedNode = null;
        }
    }
    makeNodeVisible(node) {
        setTimeout(() => {
            const selector = `.treenode[id="${node.Id}"]`;
            const selectedNodeElement = document.querySelector(selector);
            if (!selectedNodeElement) {
                return;
            }
            selectedNodeElement.scrollIntoView();
        }, 100);
    }
}
angular.module('app').component('testExecutionView', {
    bindings: {},
    controllerAs: 'vm',
    controller: TestExecutionViewController,
    templateUrl: 'scripts/app/partials/TestExecution/test-execution-view.tpl.html'
});
